"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onVideoAddTrack;
var _onActiveQualityChanged = _interopRequireDefault(require("./onActiveQualityChanged"));
var _TheoQualityHelper = require("../TheoQualityHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function onVideoAddTrack(event) {
  event.track.addEventListener('activequalitychanged', _onActiveQualityChanged["default"].bind(this));
  this._qualities = (0, _TheoQualityHelper.normaliseQualities)(this.src, event.track.qualities);
  this.emit('addtrack', event);
}